import { Box } from '@mui/material'
import { Button } from 'Common/Supplyvue-ui'
import { EmptyStateProps } from './EmptyState.types'

/**
 * What a region says when it has nothing to show, and the action that fixes it
 * (design system: EmptyState). A 28px outline icon, a 14px title, one line of
 * explanation, an optional action. No illustrations: the old 200px SVGs
 * brought their own palette into a system that has one.
 */
export const EmptyState = ({
  icon,
  title,
  text,
  actionText,
  handleClick,
}: EmptyStateProps) => {
  const heading = title ?? text
  const body = title ? text : undefined

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '8px',
        py: '32px',
        px: '24px',
        flexGrow: 1,
      }}
    >
      {icon && (
        <Box
          aria-hidden="true"
          sx={{
            color: 'var(--ink-300)',
            display: 'flex',
            '& svg': { width: 28, height: 28, fontSize: 28 },
          }}
        >
          {icon}
        </Box>
      )}
      <Box
        sx={{
          fontSize: 14,
          fontWeight: 700,
          color: 'var(--ink-700)',
          maxWidth: 420,
        }}
      >
        {heading}
      </Box>
      {body && (
        <Box sx={{ fontSize: 12, color: 'var(--ink-500)', maxWidth: 320 }}>
          {body}
        </Box>
      )}
      {actionText && handleClick && (
        <Box sx={{ mt: '8px' }}>
          <Button variant="contained" onClick={handleClick}>
            {actionText}
          </Button>
        </Box>
      )}
    </Box>
  )
}
